import { useCallback, useState } from 'react';

export const usePublicChainsCheckbox = () => {
  const [isChecked, setIsChecked] = useState(false);

  const onChange = useCallback((isSelected: boolean) => {
    setIsChecked(isSelected);
  }, []);

  return {
    isChecked,
    onClick: onChange,
  };
};
